import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { parseHtml } from '@change-corgi/core-react/html';

import { useLoginOrSignupBanner } from './hooks/useLoginOrSignupBanner';

export const LoginOrSignupBanner: React.FC = () => {
	const {
		data: { messageHtml },
	} = useLoginOrSignupBanner();

	if (!messageHtml) return null;

	return (
		<Alert type="page" variant="error" data-qa="login-or-signup-error-banner" data-testid="flash-error">
			{parseHtml(messageHtml)}
		</Alert>
	);
};
